import { RuleIds } from "../models/KnxRule";
import ManufacturerButtonRules from "./Button/ManufacturerButtonRules";
import ManufacturerDecentralActorRules from "./DecentralActor/ManufacturerDecentralActorRules";

export default function getManufacturRule(
  type: "DecentralActor" | "Actor" | "Button" | "Sensor",
  manufacturerId: string,
  ruleId: RuleIds,
): string | undefined {
  if (type == "DecentralActor") {
    let sRule = ManufacturerDecentralActorRules[manufacturerId]?.[ruleId];
    if (!sRule) {
      sRule = ManufacturerDecentralActorRules["M-xxxx"]?.[ruleId];
    }

    if (sRule) {
      sRule += "\n  return res; \n"; // no itx
    }
    return sRule;
  } else if (type != "Actor") {
    let sRule = ManufacturerButtonRules[manufacturerId]?.[ruleId];
    if (!sRule) {
      sRule = ManufacturerButtonRules["M-xxxx"]?.[ruleId];
    }

    if (sRule) {
      sRule += "\n  return res; \n"; // no itx
    }
    return sRule;
  }

  return undefined;
}
